import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Autocomplete, Paper, TextField } from "@mui/material";
import Button from "../../components/Button";

import { getPositions } from "../../api/positions";
import { getOperationById, updateOperation } from "../../api/operations";
import "./index.scss";

const OperationsEdit = ({ match, history }) => {
  const { t } = useTranslation();
  const [newOperationName, setNewOperationName] = useState("");
  const [positions, setPositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);

  const [operationErrorText, setOperationErrorText] = useState(null);
  const [positionsErrorText, setPositionsErrorText] = useState(null);

  const [isDataFetching, setIsDataFetching] = useState(false);

  useEffect(() => {
    (async () => {
      setIsDataFetching(true);
      const operation = await getOperationById(match.params.operationId);

      setNewOperationName(operation.name);
      setSelectedPositions(operation.positions);

      let newPositions = await getPositions();
      setPositions(newPositions);
      setIsDataFetching(false);
    })();
  }, [match.params.operationId]);

  function handleOperationName(value) {
    setNewOperationName(value);
    if (!value) return setOperationErrorText(t("operations_page.operation_name_required"));
    setOperationErrorText(null);
  }

  function handleSelectedPositions(value) {
    setSelectedPositions(value);
    if (!value.length) return setPositionsErrorText(t("operations_page.positions_required"));
    setPositionsErrorText(null);
  }

  async function editOperation() {
    if (!selectedPositions.length) return handleSelectedPositions(selectedPositions);
    if (!newOperationName) return handleOperationName(newOperationName);

    const operationId = match.params.operationId;

    const positionIdList = selectedPositions.map((position) => position.id);
    const result = await updateOperation(operationId, {
      name: newOperationName,
      positionIdList: positionIdList,
    });
    if (result.ok) {
      history.push("/operations");
    }
  }

  return (
    <>
      <h2>{t("operations_page.edit_title")}</h2>

      <Paper variant="outlined" className="edit-operation" style={{ padding: "1rem 1.5rem" }}>
        {!isDataFetching ? (
          <>
            <Autocomplete
              className="select-position"
              size="small"
              multiple
              options={positions}
              getOptionLabel={(position) => position.name}
              filterSelectedOptions
              defaultValue={selectedPositions}
              value={selectedPositions}
              onChange={(event, newPositions) => handleSelectedPositions(newPositions)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={t("position.select")}
                  error={!!positionsErrorText}
                  helperText={positionsErrorText}
                />
              )}
            />
            <TextField
              className="edit-field"
              variant="outlined"
              size="small"
              label={t("operations_page.operation_name_required_label")}
              value={newOperationName}
              onChange={(event) => handleOperationName(event.target.value)}
              error={!!operationErrorText}
              helperText={operationErrorText}
            />
            <Button title={t("operations_page.save_action")} onClick={editOperation}>
              {t("operations_page.save_operation")}
            </Button>
            <Button title={t("navigate_back")} onClick={() => history.goBack()}>
              {t("cancel")}
            </Button>
          </>
        ) : null}
      </Paper>
    </>
  );
};

export default OperationsEdit;
